import React, { useState, useEffect } from "react";
import BlogItem from "./BlogItem";
import { useLocation, Link } from "react-router-dom";
import axiosConfig from "../../Service/AxiosConfig";
import BreadCrumb from "../FriendlyUrlComponent/BreadCrumb";
import Justaclickaway from "../JustaClickaway/Justaclickaway";
const BlogDetail = ({ item }) => {
  const location = useLocation();
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const GetRelatedList = async () => {
    try {
      const response = await axiosConfig.get(
        `/blogapp/blog/?page_size=3&category=${""}`
      );
      setRelatedBlogs(response.data.results);
    } catch (error) {
      console.log("Error getting related blog data :", error);
    }
  };

  useEffect(() => {
    GetRelatedList();
  }, []);

  const prev_sub_page = {
    link: `/blog`,
    text: "Blog",
    state: null,
  };

  if (!item) return null;

  return (
    <div>
      <section className="about-breadcrumb">
        <BreadCrumb
          active_page={item?.title}
          prev_sub_page={prev_sub_page}
        />
      </section>
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="blog-detail">
              <h2>{item?.title}</h2>
              <img src={item?.image?.image} className="img-fluid" />
              <div
                dangerouslySetInnerHTML={{ __html: item?.content }}
                className="article"
              />
              <span className="topic">#{item?.category?.title}</span>
              <h3 className="recommended">Recommended Topics</h3>
              {relatedBlogs.length > 0 &&
                relatedBlogs.map((blog) => (
                  <>
                    <div className="detail-list">
                      <div className="list">
                        <BlogItem item={blog} />
                      </div>
                    </div>
                  </>
                ))}
            </div>
          </div>
          <div className="col-md-4">
            {/* Empty space for right sidebar */}
            <div className="justclickaway-wrapper">
              <Justaclickaway layout="single" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
